import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../library/button/button';
import Typography from '../../../../library/typography/typography';
import BundleItemProductDescription from '../../../bundle-item-product-description/bundle-item-product-description';
import ModifyEntryConfirmation, {
  ACTIONS
} from '../../../modify-entry-confirmation/modify-entry-confirmation';
import ProductDescription from '../../../product-description/product-description';
import ProductImage from '../../../product-image/product-image';
import ProductOECompatible from '../../../product-oe-compatible/product-oe-compatible';
import ProductSwatchDescription from '../../../product-swatch-description/product-swatch-description';

import { getNormalizedProductType } from '../../../../shared/utils/product/product';

import { PRODUCT_TYPES } from '../../../../shared/constants/products';

import './staggered-package-description.scss';

function StaggeredPackageDescription(props) {
  const {
    groupEntry,
    hideChangeProduct,
    isPackage,
    pendingAction,
    onConfirmChangeProduct,
    onChangeProduct,
    onCancel,
    shouldShowCartPrice = false,
    hideProductType = false
  } = props;
  const { entries } = groupEntry;
  const productType = getNormalizedProductType(entries[0]?.product);

  const vendorFinish = groupEntry.entries[0]?.product.vendorFinish;
  const isOtherVehiclesOE = groupEntry.entries[0]?.product.isOtherVehiclesOE;
  const entriesTotalQuantity = entries.reduce(
    (sum, entry) => sum + (entry?.quantity || 0),
    0
  );

  return (
    <>
      <div
        className="staggered-package-description"
        styleName={`container ${
          !isPackage || isOtherVehiclesOE ? 'container--without-border' : ''
        }`}
      >
        {!hideProductType && (
          <Typography
            styleName="product-type"
            tag="div"
            variant="H5"
            weight="black"
          >
            {productType}
          </Typography>
        )}
        <div styleName="description-container">
          <ProductImage
            height={114}
            product={entries[0]?.product}
            showAngleImage
            styleName="image"
            width={114}
          />
          <div>
            <ProductDescription
              brand={groupEntry.entries[0].product.brand}
              className="staggered-description__product-description"
              gbb={groupEntry.entries[0].product.gbb}
              name={groupEntry.entries[0].product.name}
              productType={productType}
            />
            {vendorFinish && productType === PRODUCT_TYPES.WHEELS && (
              <div styleName="swatch-description">
                <ProductSwatchDescription finish={vendorFinish} />
              </div>
            )}
            <div className="display-sm">
              <div styleName="package-entries">
                {pendingAction?.entryIndex === 0 ? (
                  <ModifyEntryConfirmation
                    action={pendingAction.type}
                    onCancel={onCancel}
                    onConfirm={onConfirmChangeProduct}
                    productType={productType}
                  />
                ) : (
                  <BundleItemProductDescription
                    axleType="FRONT"
                    entry={entries[0]}
                    hideBrand
                    hideGbb
                    hideImage
                    hideLabel
                    hideName
                    isPriceForEach
                    isStaggered
                    shouldShowCartPrice={shouldShowCartPrice}
                    showMinimumPriceMessage
                    totalQuantity={entriesTotalQuantity}
                  />
                )}
                {pendingAction?.entryIndex === 1 ? (
                  <ModifyEntryConfirmation
                    action={pendingAction.type}
                    onCancel={onCancel}
                    onConfirm={onConfirmChangeProduct}
                    productType={productType}
                  />
                ) : (
                  <BundleItemProductDescription
                    axleType="REAR"
                    entry={entries[1]}
                    hideBrand
                    hideGbb
                    hideImage
                    hideLabel
                    hideName
                    isPriceForEach
                    isStaggered
                    shouldShowCartPrice={shouldShowCartPrice}
                    showMinimumPriceMessage
                    totalQuantity={entriesTotalQuantity}
                  />
                )}
              </div>
            </div>
            <div className="display-sm">
              {onChangeProduct && !hideChangeProduct && (
                <Button
                  onClick={() => onChangeProduct(ACTIONS.CHANGE, 0)}
                  size="regular"
                >
                  change {productType?.toLowerCase()}
                </Button>
              )}
            </div>
          </div>
        </div>
        <div className="hide-sm">
          <div styleName="package-entries">
            {pendingAction?.entryIndex === 0 ? (
              <ModifyEntryConfirmation
                action={pendingAction.type}
                onCancel={onCancel}
                onConfirm={onConfirmChangeProduct}
                productType={productType}
              />
            ) : (
              <BundleItemProductDescription
                axleType="FRONT"
                entry={entries[0]}
                hideBrand
                hideGbb
                hideImage
                hideLabel
                hideName
                isPriceForEach
                isStaggered
                shouldShowCartPrice={shouldShowCartPrice}
                showMinimumPriceMessage
                totalQuantity={entriesTotalQuantity}
              />
            )}
            {pendingAction?.entryIndex === 1 ? (
              <ModifyEntryConfirmation
                action={pendingAction.type}
                onCancel={onCancel}
                onConfirm={onConfirmChangeProduct}
                productType={productType}
              />
            ) : (
              <BundleItemProductDescription
                axleType="REAR"
                entry={entries[1]}
                hideBrand
                hideGbb
                hideImage
                hideLabel
                hideName
                isPriceForEach
                isStaggered
                shouldShowCartPrice={shouldShowCartPrice}
                showMinimumPriceMessage
                totalQuantity={entriesTotalQuantity}
              />
            )}
          </div>
        </div>
        <div className="hide-sm">
          {onChangeProduct && !hideChangeProduct && (
            <Button
              onClick={() => onChangeProduct(ACTIONS.CHANGE, 0)}
              size="regular"
            >
              change {productType?.toLowerCase()}
            </Button>
          )}
        </div>
        {isOtherVehiclesOE && (
          <ProductOECompatible styleName="product-oe-compatible" />
        )}
      </div>
    </>
  );
}

StaggeredPackageDescription.propTypes = {
  groupEntry: PropTypes.object,
  hideChangeProduct: PropTypes.bool,
  hideGbb: PropTypes.bool,
  hideImage: PropTypes.bool,
  hideProductType: PropTypes.bool,
  isPackage: PropTypes.bool,
  onCancel: PropTypes.func,
  onChangeProduct: PropTypes.func,
  onConfirmChangeProduct: PropTypes.func,
  pendingAction: PropTypes.object,
  shouldShowCartPrice: PropTypes.bool
};

export default StaggeredPackageDescription;
